import React from 'react';

const DateShowCart = () => {
    return (
        <div className='small-cart-date-showcase '>
            <p className='date-show'>July 13, 2021</p>
            <div className='date-details-show'>
                <div className='custom-border'>
                    <div className='inner-custom-border'>
                        <span className='m-0'>15 / 234</span> <br />
                        <span>Sept 25</span>
                    </div>
                </div>
            </div>
            <p className='date-show pt-2'>5h ago</p>
        </div>
    );
};

export default DateShowCart;